import $ from "jquery";

export default {
    data() {
        return {
            alreadyInit: false,
            tv: null,
            playerDefaults: null,
            vid: null,
            loadingVideo: false,
        };
    },
    watch: {},
    methods: {
        initVid(activeItem) {
            this.loadingVideo = true
            this.hidePlayer()

            if (this.alreadyInit) {
                setTimeout(() => {
                    this.vid = {
                        "videoId": activeItem.videoID,
                        "startSeconds": activeItem.videoStartSec,
                        "suggestedQuality": "hd1080"
                    }
                    this.tv.loadVideoById(this.vid)
                }, 500)
                return
            }


            var tag = document.createElement("script");
            tag.src = "https://www.youtube.com/player_api";
            var firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


            this.playerDefaults = {
                autoplay: 0,
                autohide: 1,
                modestbranding: 0,
                rel: 0,
                loop: 1,
                showinfo: 0,
                controls: 0,
                disablekb: 1,
                enablejsapi: 0,
                iv_load_policy: 3
            };

            this.vid = {
                "videoId": activeItem.videoID,
                "startSeconds": activeItem.videoStartSec,
                "suggestedQuality": "hd1080"
            },

                window.onYouTubePlayerAPIReady = () => {
                    this.tv = new YT.Player("tv", {
                        events: {
                            "onReady": onPlayerReady,
                            "onStateChange": onPlayerStateChange
                        },
                        playerVars: this.playerDefaults
                    });
                }

            window.onPlayerReady = () => {

                this.tv.loadVideoById(this.vid);
                this.tv.mute();
                vidRescale();
            }

            window.onPlayerStateChange = (e) => {
                if (e.data === 1) {
                    this.loadingVideo = false
                    $("#tv").addClass("active");
                }
            }

            window.vidRescale = () => {
                var w = $(window).width(),
                    h = $(window).height();

                let $tvScreen = $(".tv .screen")

                if (w / h > 16 / 9) {
                    this.tv.setSize(w, w / 16 * 9);
                    $tvScreen.css({"left": "0px"});
                } else {
                    this.tv.setSize(h / 9 * 16, h);
                    $tvScreen.css({"left": -($tvScreen.outerWidth() - w) / 2});
                }
            }

            $(window).on("load resize", function () {
                vidRescale();
            });

            this.alreadyInit = true

        },
        hidePlayer() {

            if (this.tv !== null) {
                $("#tv").removeClass("active");
                this.tv.pauseVideo()
            }
        },
        resumePlay() {
            if (this.tv !== null && this.activeTypeVideo) {
                this.tv.playVideo()
            }
        }
    },
    created() {

    }
};